<div class="mask-modal-side-bar" [ngClass]="{open: show == true}">
    <div (click)="closeModal()" class="close-area"></div>
    <aside>
        <div class="top">
            <h3 *ngIf="modalData">{{modalData.title}}</h3>
            <div class="close-button">
                <button id="close" (click)="closeModal()"></button>
            </div>
        </div>
        <p [innerHTML]="modalData.description"></p>
        <div style="margin-bottom: 20px;" *ngIf="modalData.disclaimerInfo"></div>

        <app-alert *ngIf="modalData.disclaimerInfo"  [id]="'modal-disclaimer'" [tipo]="'info'" >
          {{modalData.disclaimerInfo}}
        </app-alert>

      </aside>
</div>
